import React from 'react';
import { useSelector } from 'react-redux';

const useUserRole = () => {
  return useSelector((state) => state.user.currentUser.role);
};

export default useUserRole;
